'use strict';

angular.module('app')
    .controller('PrinterConfigController', ['$scope', 'PrinterConfig', 'PrintService', '$translate', function ($scope, PrinterConfig, PrintService, $translate) {
        //taken from https://www.w3resource.com/javascript/form/ip-address-validation.php
        var IP_ADDRESS_VALIDATION_REGEX = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        $scope.printerConfig = {};
        $scope.printerTypes = PrintService.printerTypes;

        var validate = function () {
            if (!_.get($scope, 'printerConfig.printerType')) {
                $scope.noPrinterType = true;
                return false;
            }
            if ($scope.printerConfig.printerIpAddress.toLowerCase() !== PrintService.TEST_SUCCESS_IP
                && $scope.printerConfig.printerIpAddress.toLowerCase() !== PrintService.TEST_FAIL_IP) {
                var validIp = IP_ADDRESS_VALIDATION_REGEX.test($scope.printerConfig.printerIpAddress);
                if (!validIp) {
                    $scope.invalidIp = true;
                    return false;
                }
            }
            $scope.invalidIp = false;
            $scope.noPrinterType = false;
            return true;
        };

        $scope.printerTypeChanged = function () {
            $scope.noPrinterType = _.isNil(_.get($scope, 'printerConfig.printerType'));
        };

        $scope.testPrint = function () {
            if (!_.get($scope.printerConfig, 'printerType')) {
                bootbox.alert({
                    title: $translate.instant('recipeViewer.global.oops'),
                    message: $translate.instant('recipeViewer.print.printerTypeRequired'),
                    buttons: {
                        ok: {
                            label: $translate.instant("recipeViewer.global.ok")
                        }
                    }
                });
            } else if (_.get($scope.printerConfig, 'printerType') === 'EPSON' && !_.get($scope.printerConfig, 'printerDeviceId')) {
                bootbox.alert({
                    title: $translate.instant('recipeViewer.global.oops'),
                    message: $translate.instant('recipeViewer.print.deviceIdRequired'),
                    buttons: {
                        ok: {
                            label: $translate.instant("recipeViewer.global.ok")
                        }
                    }
                });
            } else if (_.get($scope.printerConfig, 'printerIpAddress')) {
                if (!validate()) {
                    return;
                }
                PrintService.testPrint($scope.printerConfig);
            } else {
                bootbox.alert({
                    title: $translate.instant('recipeViewer.global.oops'),
                    message: $translate.instant('recipeViewer.print.ipAddressRequired'),
                    buttons: {
                        ok: {
                            label: $translate.instant("recipeViewer.global.ok")
                        }
                    }
                });
            }
        };

        $scope.savePrinterConfig = function () {
            if (!validate()) {
                return;
            }
            $scope.invalidIp = false;
            $scope.noPrinterType = false;
            PrinterConfig.savePrinterConfig($scope.printerConfig).$promise.then(function () {
                bootbox.alert({
                    title: $translate.instant('recipeViewer.print.printerSaveSuccessTitle'),
                    message: $translate.instant('recipeViewer.print.printerSaveSuccessMsg'),
                    buttons: {
                        ok: {
                            label: $translate.instant("recipeViewer.global.ok")
                        }
                    }
                });
            }).catch(function () {
                bootbox.alert({
                    title: $translate.instant('recipeViewer.global.oops'),
                    message: $translate.instant('recipeViewer.print.errorOnPrinterSaving'),
                    buttons: {
                        ok: {
                            label: $translate.instant("recipeViewer.global.ok")
                        }
                    }
                });
            });
        };

        PrinterConfig.current().$promise.then(function (result) {
            $scope.printerConfig = result;
        });
    }]);